module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-15-e98e9d4c3032bee17bcf8be85edc3216.jpg";